exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.setup{top:0;left:0;display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;height:100vh;width:100vw;min-height:20rem;background:linear-gradient(150deg,#5ed6eb,#228cc5 80%,#228cc5);overflow-y:auto}.setup .headerBar{min-height:6rem;width:100%;margin-bottom:6rem}.setup .headerBar .messagebar{width:63%;left:18%;margin-top:3rem}@media (max-width:599px){.setup .headerBar{padding-bottom:0;margin-bottom:2rem}.setup .headerBar .messagebar{width:96%;left:1%;margin-top:0}}@media (min-width:1024px){.setup .headerBar .messagebar{width:31.5rem;left:calc(50% - 16rem)}}body{margin:0;overflow-x:hidden}.transitionContainer{width:100%;display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/setup/styles.scss
// module id = 1016
// module chunks = 0